export class CreateUpdateDriverBlockEntity {
  driverId?: number
  blockedDate?: Date
  unblockedDate?: Date
}
